module.exports = __webpack_public_path__ + "static/media/TwitchGlitchWhite.1450d19e.svg";